import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ErrorMessage from './ErrorMessage.js';
import SuccessMessage from './SuccessMessage.js';
import './DataCollectionAdd.css';
import { API_BASE, authHeaders } from '../utils/Utils.js';
import i18n from '../../i18n.js';
export const AddDataCollection = (props) => {
  const { t } = useTranslation();
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [formKey, setFormKey] = useState(0);
  const url = `${API_BASE}/api/data/${props.collection}`;
  const submit = (formData) => {
    const body = props.getBodyFromForm(formData);
    fetch(url, {
      method: 'POST',
      headers: authHeaders({ "Content-Type": "application/json" }),
      body: body,
    })
    .then(response => {
      if (response.ok) {
        if (props.successMsg) {
          setErrorMessage("");
          setSuccessMessage(props.successMsg);
          setFormKey(k => k + 1);
        } else {
          return response.json().then(data => props.onSuccess(data));
        }
        return;
      }
      if (response.status === 401) {
        localStorage.removeItem('zapmanejo_token');
        localStorage.removeItem('zapmanejo_user');
        window.location.reload();
        return;
      }
      return response.text().then(text => {
        setSuccessMessage("");
        if (text.trim() === "duplicate_key_error") {
          setErrorMessage(props.duplicateMsg);
          return;
        }
        // Newer handlers send {"error": "<i18n_key>"} instead of plain text
        // (see Fetch() in Utils.js) so the real reason can be localized here
        // instead of always falling back to a generic message — this form
        // does its own fetch rather than going through Fetch(), so the same
        // parsing is duplicated here rather than routing 28 call sites
        // through a shared helper.
        try {
          const parsed = JSON.parse(text);
          if (parsed && typeof parsed.error === 'string' && parsed.error) {
            setErrorMessage(i18n.t(parsed.error, { defaultValue: parsed.error }));
            return;
          }
        } catch (e) {
          // Not JSON — fall through to the generic message below.
        }
        setErrorMessage(`Error: ${props.collection}`);
      });
    })
    .catch(error => {
      console.error('Error updating form data:', error);
    });
  }
  return (
    <form class="DataCollectionAdd" action={submit}>
      <props.formElements key={formKey}/>
      <button type="submit">{t("add_button")}</button>
      <SuccessMessage message={successMessage}/>
      <ErrorMessage message={errorMessage}/>
    </form>
  );
}
export default AddDataCollection;
